<template>
  <div class="companies">
    <el-divider content-position="left">公司管理</el-divider>
    <el-row>
      <el-col :span="10">
        <el-select v-model="searchArr.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司" size="mini"
          clearable :remote-method="searchRemoteCompanyMethod" :loading="searchLoading"
          @change="handleSearchCompanyChange">
          <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id" :label="searchCompany.company_name"
            :value="searchCompany.id">
          </el-option>
        </el-select>
        <el-cascader v-model="searchArr.area_park" clearable :options="areas" size="mini"
          :props="{ expandTrigger: 'hover' }" @change="handleAreaChange">
        </el-cascader>
        <el-popover placement="bottom-start" v-model="visible" width="520">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="绑定客户" prop="isBind">
              <el-select v-model="searchArr.isBind" placeholder="是否绑定客户" clearable size="mini">
                <el-option label="已绑定" :value="1"></el-option>
                <el-option label="未绑定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业微信" prop="wxWorkisBind">
              <el-select v-model="searchArr.wxWorkisBind" placeholder="是否绑定企业微信" clearable size="mini">
                <el-option label="已绑定" :value="1"></el-option>
                <el-option label="未绑定" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公众号" prop="isBindWx">
              <el-select v-model="searchArr.isBindWx" placeholder="是否关注公众号" clearable size="mini">
                <el-option label="已关注" :value="1"></el-option>
                <el-option label="未关注" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="财税负责人" prop="leader_id">
              <el-select v-model="searchArr.leader_id" placeholder="请选择财税负责人筛选" filterable clearable size="mini">
                <el-option :value="null" label="NULL"></el-option>
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="理票会计" prop="acc_id">
              <el-select v-model="searchArr.acc_id" placeholder="请选择理票会计筛选" filterable clearable size="mini">
                <el-option :value="null" label="NULL"></el-option>
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客服会计" prop="ass_id">
              <el-select v-model="searchArr.ass_id" placeholder="请选择客服会计筛选" filterable clearable size="mini">
                <el-option :value="null" label="NULL"></el-option>
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="记账报税会计" prop="advisory_id">
              <el-select v-model="searchArr.advisory_id" placeholder="请选择记账报税会计筛选" filterable clearable size="mini">
                <el-option :value="null" label="NULL"></el-option>
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票会计" prop="invoice_id">
              <el-select v-model="searchArr.invoice_id" placeholder="请选择开票会计筛选" filterable clearable size="mini">
                <el-option :value="null" label="NULL"></el-option>
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务员" prop="saler_id">
              <el-select v-model="searchArr.saler_id" placeholder="请选择业务员筛选" filterable clearable size="mini">
                <el-option :value="null" label="NULL"></el-option>
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成立时间条件" prop="is_date_of_est">
              <el-radio-group v-model="searchArr.is_date_of_est" size="mini">
                <el-radio label="1" border>是</el-radio>
                <el-radio label="2" border>否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否有档案" prop="archives">
              <el-radio-group v-model="searchArr.archives" size="mini">
                <el-radio label="1" border>是</el-radio>
                <el-radio label="2" border>否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="服务状态" prop="server_status">
              <el-select v-model="searchArr.server_status" multiple placeholder="请选择" style="width: 100%" clearable
                filterable size="mini">
                <el-option label="未知" :value="1">
                </el-option>
                <el-option label="服务中" :value="2">
                </el-option>
                <el-option label="交接入" :value="3">
                </el-option>
                <el-option label="流失" :value="4">
                </el-option>
                <el-option label="暂停服务" :value="5">
                </el-option>
                <el-option label="停止服务" :value="6">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成立时间" prop="date_of_est">
              <el-date-picker v-model="searchArr.date_of_est" type="month" size="mini" value-format="yyyy-MM"
                placeholder="选择年/月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="匹配渠道" prop="checkCompanyName">
              否
              <el-switch v-model="searchArr.checkCompanyName" active-color="#13ce66" inactive-color="#909399">
              </el-switch>
              是
            </el-form-item>
            <el-form-item style="text-align: right">
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-col :span="14" style="text-align: right;">
        <el-button type="primary" @click="changeComPark" size="mini">一键更换公司园区</el-button>
        <el-upload style="display:inline-block" action="https://weixin.qiyehuo.com/api/compnay_com/import_share"
          :headers="headers" ref="uploadMutiple" :show-file-list="false" :on-success="importedReturn">
          <el-button type="success" size="mini">导入共享人</el-button>
        </el-upload>
      </el-col>
    </el-row>




    <el-table :data="companies" size="medium" border style="width: 100%; margin-top: 0.2rem" v-cloak>
      <el-table-column label="公司id" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.id">
            <span>{{ scope.row.id }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="公司" prop="company_name" width="300">
        <template slot-scope="scope">
          <div style="white-space: nowrap;width: 5rem;overflow: auto;">
            <el-tooltip :content="scope.row.company_name" placement="top" style="display: inline-block">
              <el-link type="primary" class="count-style" @click="handleCompanyInfoOpen(scope.row.id)">{{
                scope.row.company_name }}</el-link>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="复制" placement="top">
              <i class="el-icon-document-copy" style="margin-left:0.1rem;cursor:pointer"
                @click="copySome(scope.row.company_name)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="生成二维码" placement="top">
              <i class="el-icon-camera-solid" style="margin-left:0.1rem;cursor:pointer;color:#409EFF"
                @click="createQrCode(scope.row.company_name, scope.row.id)"></i>
            </el-tooltip>
            <template v-if="scope.row.self_flag === 1">
              <el-tooltip class="item" effect="dark" content="当前公司为自家公司" placement="top">
                <i class="el-icon-s-flag" style="margin-left: 0.1rem;cursor:pointer;color: red;"></i>
              </el-tooltip>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="档案号" prop="archives" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.archives">
            {{
              scope.row.archives.area +
              scope.row.archives.line +
              "-" +
              scope.row.archives.acode
            }}
          </div>
          <div v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column label="所属园区" width="120">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.address_park" placement="top">
            <span class="count-style">{{ scope.row.address_park }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="客户" prop="customer_name" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.customer">
            <el-link type="primary" :underline="false" style="padding: 0; border: none;" slot="reference"
              @click="handleShowPayerContent(scope.row)">{{ scope.row.customer.name }}({{ scope.row.customer.id
              }})</el-link>
            <!-- <span>{{ scope.row.customer.name }} ({{ scope.row.customer.id }})</span> -->
            <el-tooltip v-if="scope.row.customer && scope.row.customer_follow_pub" content="该客户已关注公众号" placement="top">
              <i style="color: #67c23a" class="ukfont">&#xe652;</i>
            </el-tooltip>
          </div>
          <el-button v-else icon="el-icon-user" circle size="mini"
            @click="handleOpenCustomer(scope.$index, scope.row.id)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="客户手机" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.customer">
            <el-tooltip :content="scope.row.customer.phone" placement="top">
              <span class="count-style"><el-link style="color: #409EFF;cursor: pointer"
                  @click="openPhoneFromDraw(scope.row.customer.phone)">{{ scope.row.customer.phone }}</el-link>
                <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                  <i @click="makePhone(scope.row.customer.phone)" class="el-icon-phone-outline"
                    style="color: #409EFF;cursor:pointer;"></i>
                </el-tooltip>
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="对接人(客户)" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.docking_name">{{
            scope.row.docking_name
          }}</span>
          <el-button v-else icon="el-icon-user" circle size="mini"
            @click="handleOpenDocking(scope.$index, scope.row.id)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="对接人手机" width="120">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.docking_phone" placement="top">
            <span class="count-style">{{ scope.row.docking_phone }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="业务员">
        <template slot-scope="scope">
          <span>{{ scope.row.salers ? scope.row.salers.username : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="财税负责人">
        <template slot-scope="scope">
          <span>{{
            scope.row.leader_id ? scope.row.com_fiscal_tax.leader.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="理票会计">
        <template slot-scope="scope">
          <span>{{
            scope.row.acc_id ? scope.row.com_fiscal_tax.acc.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客服会计">
        <template slot-scope="scope">
          <span>{{
            scope.row.ass_id ? scope.row.com_fiscal_tax.ass.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="记账报税会计">
        <template slot-scope="scope">
          <span>{{
            scope.row.advisory_id
            ? scope.row.com_fiscal_tax.advisory.username
            : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票会计">
        <template slot-scope="scope">
          <span>{{
            scope.row.invoice_id
            ? scope.row.com_fiscal_tax.invoice.username
            : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in col" :key="index" :label="item.label" :prop="item.prop" width="120">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row[item.prop]" placement="top">
            <span class="count-style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="230">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle
              @click="handCallLogsOpen(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="服务事项录入" placement="top">
            <el-button type="success" @click="serviceIn(scope.row)" size="mini" icon="el-icon-s-flag" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="微信群绑定" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" circle
              @click="handBindWxgroupsOpen(scope.row.id)"></el-button>
          </el-tooltip>
          <!--<el-tooltip-->
          <!--class="item"-->
          <!--effect="dark"-->
          <!--content="政策绑定"-->
          <!--placement="top"-->
          <!--&gt;-->
          <!--<el-button-->
          <!--type="primary"-->
          <!--size="mini"-->
          <!--icon="el-icon-help"-->
          <!--circle-->
          <!--@click="handBindPolicy(scope.row)"-->
          <!--&gt;</el-button>-->
          <!--</el-tooltip>-->
          <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
            <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="
              handleWxChatOpen(
                scope.row.wx_work_chat_com,
                scope.row.company_name
              )
              " size="mini" icon="el-icon-s-comment" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOption.currentPage" :page-size="pageOption.pageSize" :total="pageOption.total"
      @size-change="handleSizeChange" @current-change="handleCurrentChange">
    </el-pagination>



    <el-dialog title="" :visible.sync="ShareImportInfo" append-to-body @closed="closeSelf">
      <span slot="title" style="font-weight:bold;font-size:large;color:#409eff">导入信息</span>
      <div class="import-info-style">
        <p style="color:#67C23A;font-size:medium">共成功导入{{ successNum }}条</p>
        <p style="color:#E6A23C;font-size:medium;margin-top: 0.2rem">
          公司名称未匹配{{ unCompanys.length }}条:</p>
        <div style="margin-top:0.1rem">
          <el-row gutter="20">
            <el-col :span="6" v-for="item in unCompanys" :key="item" style="margin-bottom: 0.2rem">
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div style="width:225px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                  {{ item }}</div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <p style="color:#E6A23C;font-size:medium;margin-top: 0.2rem">
          后台用户名称未匹配{{ unAdminUsers.length }}条:</p>
        <div style="margin-top:0.1rem">
          <el-row gutter="20">
            <el-col :span="6" v-for="item in unAdminUsers" :key="item" style="margin-bottom: 0.2rem">
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div style="width:225px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                  {{ item }}</div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="绑定客户" :visible.sync="customerDialogVisible" width="30%" :before-close="handleCustomerClose">
      <div>
        <el-row>
          <el-col :span="24">
            <el-input size="mini" v-model="bindUserForm.bindUserId" placeholder="请输入客户id"
              @change="handleBindUserChange"></el-input>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-col :span="12"><span>{{ selectBindUser.name }}</span></el-col>
          <el-col :span="12"><span>{{ selectBindUser.phone }}</span></el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitBindCustomer">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="服务对接人" :visible.sync="bindDuckVisible" width="20%" :before-close="handleBindDuckClose">
      <div>
        <el-row>
          <el-col>
            <el-input width="100%" size="mini" v-model="bindDuckForm.name" placeholder="请输入服务对接人姓名"></el-input>
          </el-col>
        </el-row>
        <el-row class="mt-20">
          <el-col>
            <el-input width="100%" size="mini" v-model="bindDuckForm.phone" placeholder="请输入服务对接人手机号"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitBindDuck">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer :visible.sync="serviceInDrawer" direction="rtl" size="40%">
      <template slot="title">
        <span style="font-size: 0.38rem; font-weight: 700; color: #409eff">服务事项录入</span>
      </template>
      <ser-matt-in :companyId="cId" :companyName="cName" @close="closeDrawer"></ser-matt-in>
    </el-drawer>
    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" direction="rtl" :before-close="handleCompanyInfoBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId" @reloadTable="reloadTable" :checkType="16"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog title="绑定群聊" :visible.sync="bindWxDialogVisible" width="25%" :before-close="handleBindWxClose">
      <el-select style="width: 100%;" v-model="wxBindFrom.groupId" filterable remote reserve-keyword placeholder="输入群名"
        size="mini" :remote-method="searchNameremoteMethod" :loading="searchChatLoading" clearable>
        <el-option v-for="(group, index) in wxGroups" :key="index" :label="group.contact_nick_name"
          :value="group.contact_wx_id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleWxBindSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="政策管理" :visible.sync="bindPolicy" direction="rtl" size="50%"
      style="font-size: 0.38rem; font-weight: 700; color: darkred">
      <el-select size="mini" clearable filterable remote v-model="newComp.policy_id" placeholder="请选择查询政策"
        style="width:30%" @change="changePolicy">
        <el-option v-for="item in policyObj" :key="item.id" :label="item.policy_name" :value="String(item.id)">
        </el-option>
      </el-select>
      <br><br>
      <el-table :data="Array.isArray(policyObj) ? policyObj : []" height="250" border style="width: 100%">
        <el-table-column prop="policy_name" label="政策名称">
        </el-table-column>
        <el-table-column prop="instructions" label="政策内容">
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="申请" placement="top">
              <el-button type="success" size="mini" icon="el-icon-check" circle
                @click.native.prevent="applyFor(scope.row.id)">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <br><br>
      <template>
        <!--<span style="font-size: 0.38rem; font-weight: 700; color: black;padding-left:  5px">公司申请政策</span><br><br>-->
        <el-table :data="companyPolicy" height="450" border style="width: 100%">
          <el-table-column label="公司政策列表">
            <el-table-column prop="policy_name" label="政策名称" width="180">
            </el-table-column>
            <el-table-column prop="apply_time" label="申请时间" width="180">
            </el-table-column>
            <el-table-column prop="app_status" label="申请状态">
              <template slot-scope="scope">
                <span v-if="scope.row.app_status === 1" style="color: navy">申请中</span>
                <span v-else-if="scope.row.app_status === 2" style="color: green">申请成功</span>
                <span v-else style="color: red">
                  驳 回 &nbsp;&nbsp;&nbsp;&nbsp;
                  <el-tooltip class="item" effect="dark" content="重新申请" placement="top">
                    <el-button type="success" size="mini" icon="el-icon-check" circle
                      @click.native.prevent="againApplyFor(scope.row.id)">
                    </el-button>
                  </el-tooltip>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="审核">
              <template slot-scope="scope">
                <div v-if="scope.row.app_status === 1">
                  <el-tooltip class="item" effect="dark" content="通过" placement="top">
                    <el-button type="success" size="mini" icon="el-icon-circle-plus-outline" circle
                      @click.native.prevent="auditFor(scope.row, 2)">
                    </el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="驳回" placement="top">
                    <el-button type="primary" size="mini" icon="el-icon-remove-outline" circle
                      @click.native.prevent="auditFor(scope.row, 3)">
                    </el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="驳回原因">
              <template slot-scope="scope">
                <div v-if="scope.row.app_status === 3" style="color: red">
                  {{ scope.row.why }}
                </div>
                <div v-else-if="scope.row.app_status === 1">
                  <el-input type="textarea" :rows="2" placeholder="请输入驳回内容" v-model="scope.row.why">
                  </el-input>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </template>
      <!--</template>-->
    </el-drawer>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatCompany"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <!-- 支付人详情及公司情况 开始 -->
    <el-drawer title="支付人详情及公司概况" :visible.sync="handlePayerContentDrawer" direction="rtl" :before-close="handleClose"
      size="50%" class="PayerContent">
      <!-- 组件调用 -->
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <userwith-order :PayerData="userData" :ThreadData="ThreadData" :PayerCompanyData="PayerCompanyData"
            :userOrderData="userOrderData"></userwith-order>
        </el-row>
      </div>
      <!-- 组件调用 -->
    </el-drawer>
    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->
    <!-- 沟通记录弹窗 开始-->
    <el-drawer title="沟通记录" :visible.sync="chatRecordDrawer" direction="rtl" :before-close="handleChatRecordBeforeClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
    <!-- <el-dialog title="公司名称二维码" :visible.sync="QrCodeDialog" :modal="false" width="20%" style="text-align: center">
        <qr-code :url="company_name_text" :content="company_name_text"/>
    </el-dialog> -->
    <el-dialog @close="close_QrCodeDialog" title="公司名称二维码" :visible.sync="QrCodeDialog" :modal="false" width="20%"
      style="text-align: center">
      <qrcode-logo :url="JSON.stringify({ company_name_text, company_id_text })" :iconurl="logoUrl" :wid="200" :hei="200"
        :imgwid="60" :imghei="60" />
    </el-dialog>
  </div>
</template>

<script>
import SerMattIn from 'common/ServiceMatterIn'
import MakePhone from 'common/MakePhone'
import CompanyInfo from 'common/CompanyInfo'
import CallLogs from 'common/CallLogs'
import WxWorkChat from 'common/WxWorkChat'
import UserwithOrder from 'common/UserWithOrder'
import ChatRecord from 'common/ChatRecord'
import QrCode from 'common/QRcode'
import QrcodeLogo from 'common/QRcodeLogo'
export default {
  name: 'Companies',
  components: {
    CompanyInfo,
    CallLogs,
    WxWorkChat,
    SerMattIn,
    UserwithOrder,
    ChatRecord,
    MakePhone,
    QrCode,
    QrcodeLogo
  },
  data() {
    return {
      QrCodeDialog: false,
      company_name_text: '',
      data_text: false,
      company_id_text: '',
      unCompanys: [],
      unAdminUsers: [],
      successNum: '',
      ShareImportInfo: false,
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      phoneFrom_phone: [],
      phoneFromDraw: false,
      provincesObj: {},
      cityObj: {},
      areaObj: {},
      areaparkObj: {},
      policyObj: [],
      companyPolicy: [],
      newComp: {
        id: '',
        policy_id: '',
        address_area: '',
      },
      handlePayerContentDrawer: false,
      ThreadData: {},
      userData: {},
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      PayerCompanyData: [],
      userOrderData: [],
      payerShowTab: '1',
      cName: null,
      cId: null,
      serviceInDrawer: false,
      searchArr: {
        checkCompanyName: false,
        server_status: '',
        company_id: '',
        saler_id: '',
        isBind: '',
        isBindWx: '',
        leader_id: '',
        acc_id: '',
        ass_id: '',
        advisory_id: '',
        invoice_id: '',
        is_date_of_est: '1',
        date_of_est: '',
        area_park: [],
        wxWorkisBind: '',
        archives: '',
      },
      visible: false,
      searchLoading: false,
      companies: [],
      areas: [],
      searchCompanies: [],
      adminUsers: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10, // 每页显示条数
      },
      col: [
        {
          label: '纳税人识别号',
          prop: 'taxNumber',
        },
      ],
      customerDialogVisible: false,
      bindUserForm: {
        index: null,
        id: null,
        bindUserId: '',
      },
      selectBindUser: {
        name: '',
        phone: '',
      },
      bindDuckVisible: false,
      bindDuckForm: {
        index: null,
        id: null,
        name: '',
        phone: '',
      },
      logoUrl: require('../../assets/image/qyh-logo.jpg'),
      callLogsDrawer: false,
      company: '',
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      companyInfoDrawer: false,
      companyInfoId: null,
      bindWxDialogVisible: false,
      bindPolicy: false,
      searchChatLoading: false,
      wxGroups: [],
      wxBindFrom: {
        companyId: null,
        groupId: null,
      },
      wxChatDrawer: false,
      wxWorkChatId: '',
      wxWorkchatCompany: '',
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },
    collapse() {
      return this.$store.state.collapse
    },
  },
  methods: {
    close_QrCodeDialog() {
      this.company_name_text = ''
      this.company_id_text = ''
    },
    createQrCode(company_name, company_id) {
      this.QrCodeDialog = true
      this.$nextTick(() => {
        this.company_name_text = company_name
        this.company_id_text = company_id
      })
    },
    closeSelf() {
      this.unCompanys = []
      this.unAdminUsers = []
      this.successNum = ''
    },
    importedReturn(res) {
      if (res.code === 1) {
        this.unCompanys = res.data.unCompanys
        this.unAdminUsers = res.data.unAdminUsers
        this.successNum = res.data.success
        this.ShareImportInfo = true
      }
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone)
      })
      this.phoneFromDraw = true
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }

      // this.$axios.post('/api/admin/call_logs/' + phone).then((res) => {
      this.$axios.post('api/admin/call_logs_call', {
        phone
      }).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = []
      done()
    },
    againApplyFor(e) {
      this.$axios
        .get(
          '/api/admin/policy/againapplyfor?company_policy_id=' +
          e +
          '&comp_id=' +
          this.newComp.id
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyPolicy = Array.isArray(data.data.companyPolicy)
              ? data.data.companyPolicy
              : []
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    auditFor(row, status) {
      this.$axios
        .get(
          '/api/admin/policy/auditfor?company_policy_id=' +
          row.id +
          '&status=' +
          status +
          '&rejected=' +
          row.why +
          '&comp_id=' +
          this.newComp.id
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyPolicy = Array.isArray(data.data.companyPolicy)
              ? data.data.companyPolicy
              : []
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    applyFor(e) {
      this.$axios
        .get(
          '/api/admin/policy/applyfor?policy_id=' +
          e +
          '&comp_id=' +
          this.newComp.id
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyPolicy = Array.isArray(data.data.companyPolicy)
              ? data.data.companyPolicy
              : []
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    changePolicy(e) {
      this.$axios
        .get('/api/admin/policy/shaixuanzheche?policy_id=' + e)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.policyObj = data.data.policyObj
          }
        })
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success',
      })
    },
    copySome(data) {
      this.copy(data)
    },
    handlePolicySub() {
      this.$axios
        .get(
          '/api/admin/policy/editcompanypolicy?cid=' +
          this.newComp.id +
          '&pid=' +
          this.newComp.policy_id
        )
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.bindPolicy = false
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handBindPolicy(newComp) {
      if (newComp.policy_id !== []) {
        this.newComp = newComp
      }
      this.bindPolicy = true
      this.$axios
        .get(
          '/api/admin/policy/companypolicyed?cid=' +
          newComp.id +
          '&pid=' +
          newComp.policy_id +
          '&address_area=' +
          newComp.address_area
        )
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.policyObj = data.data.policyObj
            this.companyPolicy = Array.isArray(data.data.companyPolicy)
              ? data.data.companyPolicy
              : []
            console.log('=========policyObj=====', this.policyObj)
            console.log(this.newComp)
          }
        })
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row) {
      this.ThreadData = row.customer.publicthread
      this.userData = row.customer
      this.PayerCompanyData = row.customer.company
      if (this.PayerCompanyData.length !== 0) {
        for (let item of this.PayerCompanyData) {
          item.business_man = row.customer.business.username
        }
      }
      this.handelOpenUserOrder(row.customer)
      this.handlePayerContentDrawer = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.PayerData = []
          this.handlePayerContentDrawer = false
          this.payerShowTab = '1'
          done()
        })
        .catch((_) => { })
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder(row) {
      this.$axios
        .post('/api/customer/get_customer_order', { id: row.id })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.userOrderData = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true
      setTimeout(() => {
        this.threadId = threadId
      })
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false
      this.threadId = null
      done()
    },
    reloadTable() {
      this.getCompanies()
    },
    getCompanies() {
      this.$axios
        .get(
          '/api/admin/companies?page=' +
          this.pageOption.currentPage +
          this.searchStr
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companies = data.data.companies.data
            this.pageOption.total = data.data.companies.total
            this.pageOption.currentPage = data.data.companies.current_page
            this.adminUsers = data.data.adminUsers
            this.areas = data.data.areas
          }
        })
    },
    resetForm(formName) {
      this.visible = false
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getCompanies()
    },
    submitForm(formName) {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getCompanies()
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
      this.getCompanies()
    },
    searchRemoteCompanyMethod(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanys(query)
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1
      this.getCompanies()
    },
    handleAreaChange() {
      this.pageOption.currentPage = 1
      this.getCompanies()
    },
    // handleSearchSalerChange (val) {
    //   this.pageOption.currentPage = 1
    //   this.getCompanies()
    // },
    handelShow(index, row) {
      console.log(row)
    },
    handleOpenCustomer(index, id) {
      this.bindUserForm.id = id
      this.bindUserForm.index = index
      this.customerDialogVisible = true
    },
    handleCustomerClose(done) {
      this.handleCustomerClear()
      done()
    },
    handleCustomerClear() {
      this.bindUserForm.id = null
      this.bindUserForm.index = null
      this.bindUserForm.bindUserId = ''
      this.selectBindUser.name = ''
      this.selectBindUser.phone = ''
    },
    handleBindUserChange(val) {
      if (val) {
        this.$axios
          .post('/api/admin/users/bindUserInfo', this.bindUserForm)
          .then((res) => {
            let { data } = res
            if (data.code === 0) {
              this.selectBindUser.name = data.data.user.name
              this.selectBindUser.phone = data.data.user.phone
            } else {
              this.$message.error(data.msg)
            }
          })
      }
    },
    submitBindCustomer() {
      if (!this.bindUserForm.bindUserId) {
        this.$message.error('请输入客户id')
        return
      }

      this.$axios
        .post('/api/admin/companies/bindUser', this.bindUserForm)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.companies[this.bindUserForm.index].customer =
              data.data.customer
            this.companies[this.bindUserForm.index].customer_follow_pub =
              data.data.customerFollowPub
            this.handleCustomerClear()
            this.$message.success(data.msg)
            this.customerDialogVisible = false
          }
        })
    },
    handleOpenDocking(index, id) {
      this.bindDuckForm.index = index
      this.bindDuckForm.id = id
      this.bindDuckVisible = true
    },
    clearBindDuckForm() {
      this.bindDuckForm.index = null
      this.bindDuckForm.id = null
      this.bindDuckForm.name = ''
      this.bindDuckForm.phone = ''
    },
    handleBindDuckClose(done) {
      this.clearBindDuckForm()
      done()
    },
    submitBindDuck() {
      if (!this.bindDuckForm.name) {
        this.$message.error('请输入服务对接人姓名')
        return
      }

      if (!this.bindDuckForm.phone) {
        this.$message.error('请输入服务对接人手机号')
        return
      }

      this.$axios
        .post('/api/admin/companies/bindDuck', this.bindDuckForm)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.companies[this.bindDuckForm.index].docking_name =
              this.bindDuckForm.name
            this.companies[this.bindDuckForm.index].docking_phone =
              this.bindDuckForm.phone
            this.clearBindDuckForm()
            this.bindDuckVisible = false
          }
        })
    },
    handleInvoicOpen() { },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true
      setTimeout(() => {
        this.company = row.company_name
        if (row.customer) this.callPhone.push(row.customer.phone)
        if (row.orders.length > 0) {
          for (let i = 0; i < row.orders.length; i++) {
            if (
              row.orders[i].customer_phone &&
              this.callPhone1.indexOf(row.orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.orders[i].customer_phone)
            }
            if (
              row.orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.orders[i].corporate_phone)
            }
          }
        }
        if (row.docking_phone) this.callPhone3.push(row.docking_phone)
      })
    },
    handleCallLogsBeforeClose(done) {
      this.company = ''
      this.callPhone = []
      this.callPhone1 = []
      this.callPhone2 = []
      this.callPhone3 = []
      done()
    },
    handleCompanyInfoOpen(cid) {
      setTimeout(() => {
        this.companyInfoId = cid
      }, 100)
      this.companyInfoDrawer = true
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null
      done()
    },
    handBindWxgroupsOpen(cid) {
      this.$axios.get('/api/admin/company/group/' + cid).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.wxBindFrom.companyId = cid
          this.wxBindFrom.groupId = data.data.chatId
          if (data.data.chatId) {
            this.wxGroups.push({
              contact_wx_id: data.data.chatId,
              contact_nick_name: data.data.chatName,
            })
          }
          this.bindWxDialogVisible = true
        }
      })
    },
    searchNameremoteMethod(query) {
      if (query !== '') {
        this.searchChatLoading = true
        setTimeout(() => {
          this.searchChatLoading = false
          this.searchChats(query)
        }, 200)
      } else {
        this.wxGroups = []
      }
    },
    searchChats(query) {
      this.$axios
        .get('/api/admin/qy_wx_msg/search_groups/' + query)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.wxGroups = data.data
          }
        })
    },
    handleBindWxClose(done) {
      this.wxBindFrom.companyId = null
      this.wxBindFrom.groupId = null
      this.wxGroups = []
      done()
    },
    handleWxBindSub() {
      if (!this.wxBindFrom.companyId) {
        this.$message.error('请求错误，请刷新页面重试')
        return
      }
      if (!this.wxBindFrom.groupId) {
        this.$message.error('请输入要绑定的群名！')
        return
      }

      this.$axios
        .post('/api/admin/company/group', this.wxBindFrom)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.wxBindFrom.companyId = null
            this.wxBindFrom.groupId = null
            this.wxGroups = []
            this.bindWxDialogVisible = false
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id
          this.wxWorkchatCompany = companyName
        })
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = ''
      this.wxWorkchatCompany = ''
      done()
    },
    serviceIn(row) {
      setTimeout(() => {
        this.cId = row.id
        this.cName = row.company_name
      })
      this.serviceInDrawer = true
    },
    closeDrawer() {
      this.serviceInDrawer = false
    },
    // 一键更换公司园区
    changeComPark() {
      this.$axios.post('/api/admin/company/change_address_park').then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success(data.msg)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
  },
  mounted() {
    this.getCompanies()
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.companies >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.companies {
  marginLeft();

  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 70%;
}
</style>



// WEBPACK FOOTER //
// src/pages/companies/Companies.vue